import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/app/src/components/Breadcrumb/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomePage"] */ "/app/src/components/HomePage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageScaffold"] */ "/app/src/components/PageScaffold/index.tsx");
